@if (data) {
    <div class="dine-to-finder-error-modal">
        <div class="avatar lady-tramp"></div>
        <p class="copy">
            {{ data.copy }}
        </p>
    </div>
}
